import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  templateUrl: './help-resources.component.html',
  styleUrls: ['./help-resources.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpResourcesComponent implements OnInit, OnDestroy {

  // flag to determine if this is begin viewed from employee mobile app
  isMobileApp: boolean = false;
  requestID: number = 0;

  private ngDestroy$ = new Subject();

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.ngDestroy$)).subscribe((params) => {
      this.isMobileApp = params['mobile'] === 'true' ? true : false;
      this.requestID = parseInt(params['requestID']);
    });
  }

  private handleError<T>(
    operation = 'operation',
    result?: T
  ): (error: any) => Observable<T> {
    return (error: any): Observable<T> => {

      return of(result as T);
    };
  }

  ngOnDestroy() {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }
}
